// @flow
import { takeEvery, put, call } from 'redux-saga/effects';

import { getResource, getArrayResource } from '@redux/components/ApiRequest/actions';
import { changeTitle } from '@redux/components/Metadata/actions';
import { mainApiUrl } from '@lib';
import { pageReady } from '@redux/components/Page/actions';

import {
  BLOG_ARTICLES_REQUEST,
  BLOG_ARTICLES_REQUESTED,
  BLOG_ARTICLE_REQUEST,
  BLOG_ARTICLE_REQUESTED,
  BLOG_CATEGORIES_REQUEST,
  BLOG_CATEGORIES_REQUESTED,
  BLOG_TESTIMONIALS_REQUEST,
  ITEMS_PER_PAGE
} from './constants';
import {
  errorBlogArticle,
  errorBlogArticles,
  errorBlogCategories,
  updateBlogArticle,
  updateBlogArticles,
  updateBlogCategories,
  updateBlogTestimonial
} from './actions';

import type { Action } from '../types';

export function* blogArticleRequestFlow({ slug }: Action): Generator<Function, void, void> {
  if (!slug) return;
  const url: string = `${mainApiUrl}/v1/blog_articles/${slug}`;
  yield put(getResource(url, updateBlogArticle, errorBlogArticle));
}

export function* blogArticlesRequestFlow({
  categoryTypes,
  pageNumber,
  customPerPage,
  treatment_id,
  department
}: Action): Generator<Function, void, void> {
  const url: string = `${mainApiUrl}/v1/blog_articles`;
  yield put(
    getArrayResource(url, updateBlogArticles, errorBlogArticles, {
      params: {
        category_ids: categoryTypes && categoryTypes[0] === 'all' ? [] : categoryTypes,
        per_page: customPerPage || ITEMS_PER_PAGE,
        page: pageNumber,
        treatment_id,
        department
      }
    })
  );
}

export function* blogArticleRequestedFlow({
  dataArticle
}: Action): Generator<Function, void, void> {
  yield put(changeTitle({ IN: { en: dataArticle?.attributes.title } }));
  yield put(pageReady());
}

export function* blogArticlesRequestedFlow(): Generator<Function, void, void> {
  yield put(changeTitle({ IN: { en: 'Blogs' } }));
  yield put(pageReady());
}

export function* blogCatgoriesRequestFlow(): Generator<Function, void, void> {
  const url: string = `${mainApiUrl}/v1/blog_categories`;
  yield put(getArrayResource(url, updateBlogCategories, errorBlogCategories));
}

export function* blogCatgoriesRequestedFlow(): Generator<Function, void, void> {
  yield put(pageReady());
}

export function* blogTestimonialsRequestFlow({
  customPerPage,
  treatment_id
}: Action): Generator<Function, void, void> {
  const url: string = `${mainApiUrl}/v1/blog_articles`;
  yield put(
    getArrayResource(url, updateBlogTestimonial, errorBlogArticles, {
      params: {
        category_ids: ['2ad33613-808a-40db-9900-713f54167533'], // patient stories id
        per_page: customPerPage,
        treatment_id
      }
    })
  );
}

export function* blogArticlesFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case BLOG_ARTICLES_REQUEST:
      yield call(blogArticlesRequestFlow, action);
      break;
    case BLOG_CATEGORIES_REQUEST:
      yield call(blogCatgoriesRequestFlow, action);
      break;
    case BLOG_ARTICLE_REQUEST:
      yield call(blogArticleRequestFlow, action);
      break;
    case BLOG_TESTIMONIALS_REQUEST:
      yield call(blogTestimonialsRequestFlow, action);
      break;
    case BLOG_ARTICLE_REQUESTED:
      yield call(blogArticleRequestedFlow, action);
      break;
    case BLOG_ARTICLES_REQUESTED:
      yield call(blogArticlesRequestedFlow);
      break;
    case BLOG_CATEGORIES_REQUESTED:
      yield call(blogCatgoriesRequestedFlow);
      break;
    default:
      break;
  }
}

export default function* blogArticlesWatcher(): Generator<Function, void, Action> {
  yield takeEvery(
    [
      BLOG_ARTICLES_REQUEST,
      BLOG_CATEGORIES_REQUEST,
      BLOG_ARTICLE_REQUEST,
      BLOG_TESTIMONIALS_REQUEST,
      BLOG_ARTICLE_REQUESTED,
      BLOG_ARTICLES_REQUESTED,
      BLOG_CATEGORIES_REQUESTED
    ],
    blogArticlesFlow
  );
}
